module.exports = __webpack_public_path__ + "static/media/buy_comment.ce27089f.svg";